"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { footerLinks } from "@/lib/navigation";

export function SiteFooter() {
  const pathname = usePathname();
  if (pathname.startsWith("/admin") || pathname.startsWith("/chat")) return null;

  return (
    <footer className="border-border border-t px-5 pt-8 pb-24 text-center lg:pb-8">
      <div className="mx-auto flex max-w-4xl flex-col gap-1">
        <p className="text-muted-foreground text-sm font-bold tracking-tight">skinagent</p>
        <p className="text-muted-foreground text-xs">
          (주)에이전틱스튜디오 · 대표 이용호 · 사업자등록번호 660-87-03891
        </p>
        <p className="text-muted-foreground text-xs">서울특별시 강남구 삼성동 미켈란107 6층 D184</p>
        <div className="text-muted-foreground mt-3 flex items-center justify-center gap-3 text-xs">
          {footerLinks.map((link, i) => (
            <span key={link.href} className="flex items-center gap-3">
              {i > 0 && <span className="text-gray-300">|</span>}
              <Link
                href={link.href}
                className={
                  link.bold ? "font-semibold hover:text-violet-600" : "hover:text-violet-600"
                }
              >
                {link.label}
              </Link>
            </span>
          ))}
        </div>
        <p className="text-muted-foreground mt-2 text-xs">
          고객센터 ·{" "}
          <a href="tel:1577-4051" className="text-violet-600 hover:underline">
            1577-4051
          </a>
          {" · "}
          <a href="mailto:help@skinagent.co" className="text-violet-600 hover:underline">
            help@skinagent.co
          </a>
        </p>
      </div>
    </footer>
  );
}
